import React, { useEffect } from "react";
import { TextField } from "@mui/material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Link } from "react-router-dom";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { fetchApi } from "../helper/api";
import { IsAlert } from "../component/atoms/IsAlert";
const SetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required("Password harus diisi")
      .min(6, "Password harus lebih dari 6 karakter")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Password harus terdiri dari Uppercase, Lowercase, Nomor dan Symbol"
      ),
    confirm_password: Yup.string()
      .required("Password harus diisi")
      .oneOf([Yup.ref("password")], "Password tidak sama"),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm(formOptions);

  const [values, setValues] = React.useState({
    amount: "",
    password: "",
    weight: "",
    weightRange: "",
    showPassword: false,
    errorMessage: "",
  });
  // useEffect(() => {
  //     getParam()
  // },[])
  const getParam = (index) => {
    var split = location.search.split("=");
    return split[index];
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const onSubmit = async (data) => {
    const dataPost = {
      token: getParam(1),
      email: getParam(2),
      password: data.password,
    };
    const req = await fetchApi(
      "api/User/updatePassword",
      "POST",
      false,
      dataPost
    );
    const status = req.status;
    const res = await req.json();
    if (status === 200) {
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "success",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          navigate("/login");
        }
      });
    } else {
      setValues({
        ...values,
        errorMessage: res.title,
      });
    }
    // navigate("/login")
  };
  return (
    <div className="bg_login row align-items-center m-0 justify-content-center">
      <div className="wrap_login col-lg-3 col-11 shadow p-4 bg-white rounded">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row justify-content-center mb-4">
            <div className="logo_login col-8">
              <img
                alt=""
                className="w-100"
                src="https://connect-assets.prosple.com/cdn/ff/BxxWcDLuMPteTaLBarie733WNjM1w2h2okOUBO01EpY/1636517739/public/2021-11/banner%20for%20PUPR%20893x321.png"
              />
            </div>
          </div>
          <h1 className="mb-0">Buat Password</h1>
          <div className="py-2">
            <FormControl sx={{ width: "100%" }} variant="standard">
              <InputLabel htmlFor="standard-adornment-password">
                Password
              </InputLabel>
              <Input
                id="standard-adornment-password"
                type={values.showPassword ? "text" : "password"}
                {...register("password")}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {values.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            {errors.password ? (
              <span className="text-danger">{errors.password.message}</span>
            ) : (
              ""
            )}
          </div>
          <div className="py-2">
            <FormControl sx={{ width: "100%" }} variant="standard">
              <InputLabel htmlFor="standard-adornment-password">
                Ulangi Password
              </InputLabel>
              <Input
                id="standard-adornment-password"
                type={values.showPassword ? "text" : "password"}
                {...register("confirm_password")}
                helperText={
                  errors.confirm_password ? errors.confirm_password.message : ""
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {values.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            {errors.confirm_password ? (
              <span className="text-danger">
                {errors.confirm_password.message}
              </span>
            ) : (
              ""
            )}
          </div>
          <i className="text-muted">Note : Masukan Password baru anda</i>
          <div className="py-2 mt-2">
            <Button
              className="w-100"
              variant="contained"
              color="success"
              type="submit"
            >
              <i className="las la-check-circle mr-2"></i>
              Selesai
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default SetPassword;
